<panel width="450">
  <form>
    @if (questionnaire) {
      <data-table>
        <data-row columns="12">
          <custom-input [label]="'questionnaire.name' | translate" [(value)]="updatedQuestionnaireName" [required]="true" />
        </data-row>
      </data-table>
    }
    <div class="row">
      <div class="col-6 offset-6">
        <submit-button (click)="saveQuestionnaire()" [label]="'general.save' | translate" />
      </div>
    </div>
  </form>
</panel>
